/* CGC countdown (in-house replacement for Essential Countdown). Markup: snippets/cgc-countdown.liquid.
   Modes: daily (reset at a cutoff time in a time zone), fixed (end date/time in a time zone),
   evergreen (per visitor, start kept in localStorage). One 1-second timer drives every countdown on the page. */
(function () {
  if (window.CGCCountdown) { window.CGCCountdown.init(); return; }
  var DAY = 864e5;
  var fmtCache = {};

  function fmt(tz) {
    return fmtCache[tz] || (fmtCache[tz] = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, hourCycle: 'h23', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }));
  }
  /* wall-clock parts of instant `ms` in `tz` */
  function parts(ms, tz) {
    var p = {};
    fmt(tz).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, mo: +p.month, d: +p.day, h: +p.hour % 24, mi: +p.minute, s: +p.second,
             dow: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday) };
  }
  function offset(ms, tz) {
    var p = parts(ms, tz);
    return Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s) - Math.floor(ms / 1000) * 1000;
  }
  /* the UTC instant of wall-clock y-mo-d h:mi in tz (DST-safe: re-checks the offset at the result) */
  function zoned(y, mo, d, h, mi, tz) {
    var guess = Date.UTC(y, mo - 1, d, h, mi);
    var t = guess - offset(guess, tz);
    return guess - offset(t, tz);
  }

  function endOf(el, now) {
    var ds = el.dataset, tz = ds.tz || 'America/New_York';
    try { fmt(tz); } catch (e) { tz = 'America/New_York'; }
    if (ds.mode === 'fixed') {
      var m = (ds.end || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      return m ? zoned(+m[1], +m[2], +m[3], +(m[4] || 23), +(m[5] || 59), tz) : null;
    }
    if (ds.mode === 'evergreen') {
      var key = 'cgc-cd:' + ds.key, len = (+ds.minutes || 120) * 6e4, start;
      try { start = +localStorage.getItem(key); } catch (e) {}
      if (!start || start > now) { start = now; try { localStorage.setItem(key, String(start)); } catch (e) {} }
      if (now >= start + len && ds.restart === 'true') {
        start += Math.floor((now - start) / len) * len;
        try { localStorage.setItem(key, String(start)); } catch (e) {}
      }
      return start + len;
    }
    /* daily: the next cutoff on an active weekday */
    var hm = (ds.cutoff || '23:59').split(':'), days = ds.days || '0123456';
    for (var i = 0; i < 8; i++) {
      var p = parts(now + i * DAY, tz);
      if (days.indexOf(String(p.dow)) < 0) continue;
      var t = zoned(p.y, p.mo, p.d, +hm[0], +(hm[1] || 0), tz);
      if (t > now) return t;
    }
    return null;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function render(el, now) {
    if (!el._end || now >= el._end) {
      var e = endOf(el, now);
      if (!e || e <= now) return expire(el);
      el._end = e;
    }
    var left = Math.max(0, Math.floor((el._end - now) / 1000));
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    if (el.classList.contains('cgc-cd--inline')) {
      var t = el.querySelector('[data-time]');
      var txt = d ? d + 'd ' + h + 'h ' + pad(m) + 'm' : h + 'h ' + pad(m) + 'm' + (el.dataset.seconds === 'false' ? '' : ' ' + pad(s) + 's');
      if (t.textContent !== txt) t.textContent = txt;
    } else {
      /* cache the digit nodes once and only write what changed (one text node per second, not four + two lookups) */
      var U = el._u || (el._u = {}), u = function (k) { return U[k] || (U[k] = el.querySelector('[data-u="' + k + '"]')); };
      var put = function (k, v) { var n = u(k).firstChild; if (n.textContent !== v) n.textContent = v; };
      var showD = d > 0;
      if (u('d').hidden === showD) { u('d').hidden = !showD; u('dc').hidden = !showD; }
      if (showD) put('d', pad(d));
      put('h', pad(h));
      put('m', pad(m));
      put('s', pad(s));
    }
  }

  function expire(el) {
    el._done = true;
    if (el.dataset.expired === 'message') {
      var msg = el.querySelector('.cgc-cd__expired');
      Array.prototype.forEach.call(el.children, function (c) { if (c !== msg) c.hidden = true; });
      if (msg) msg.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  var els = [];
  function init(root) {
    (root || document).querySelectorAll('[data-cgc-cd]').forEach(function (el) {
      if (el._cgc) return; el._cgc = true; els.push(el); render(el, Date.now());
    });
  }
  function tick() {
    var now = Date.now();
    els = els.filter(function (el) { return el.isConnected && !el._done; });
    els.forEach(function (el) { render(el, now); });
  }

  window.CGCCountdown = { init: init, _zoned: zoned, _end: endOf };
  init();
  setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
